import { makeStyles } from '@fluentui/react-components';
import { tokens } from '../../../../../theme/fluent';

export const useEmptyWidgetStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flexGrow: 1,
  },
  content: {
    textAlign: 'center',
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase400,
  },
  grid: {
    display: 'grid',
    placeItems: 'center',
    height: '100%',
  },
  gridInner: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: tokens.spacingVerticalXXL,
  },
});
